// angular
import { Component, forwardRef, input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-radio-button',
  standalone: true,
  imports: [FormsModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true,
    },
  ],
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
})
export class RadioButtonComponent implements ControlValueAccessor {
  public checked!: boolean;
  public disabled = false;

  // inputs
  filterName = input<string>('');
  value = input<string>('');
  label = input<string>('');
  id = input<number | string>();
  isDisabled = input<boolean>(false);

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {}

  propagateChange = (_: any) => {};

  writeValue(value: any): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
